import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseBox, BaseTypography } from "../../../Common/UI/exports";
import { ROLE_BASED_ACCESS } from "../../../Common/Constant/Security/RoleBasedAccess";

function AIMode() {
  const [selectedProcess, setSelectedProcess] = useState("");
  const navigate = useNavigate();
  const email = localStorage.getItem("email");

  const handleCardClick = (processId) => {
    setSelectedProcess(processId);
    if (processId === "ai-augmented-sdlc") {
      navigate("/ai-mode/ai-augmented-sdlc", { state: { email } });
    }else if (processId === "ai-chat-agent") {
      navigate("/ai-mode/ai-chat-agent", { state: { email } });
    }else if (processId === "ai-settings") {
      navigate("/ai-mode/ai-settings", { state: { email } });
    }
  };

  const aiTools = [
    ROLE_BASED_ACCESS.AI_MODE_SDLC() && {
      id: "ai-augmented-sdlc",
      title: "AI-Augmented SDLC",
      desc: "Enhance software development lifecycle with AI-augmented SDLC",
      icon: "🔄",
    },
    ROLE_BASED_ACCESS.AI_CHAT_AGENT() && {
      id: "ai-chat-agent",
      title: "AI Chat Agent",
      desc: "Engage with an AI chat agent to assist with various tasks",
      icon: "💬",
    },
    ROLE_BASED_ACCESS.AI_SETTINGS() && {
      id: "ai-settings",
      title: "AI Settings",
      desc: "Configure AI personas and other AI-related settings",
      icon: "⚙️",
    },
  ].filter(Boolean);

  return (
    <BaseBox
      sx={{
        textAlign: "center",
        margin: "0",
        maxWidth: "900px",
        padding: 2,
      }}
    >      

      {/* AI Tools Cards */}
      <BaseBox
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: 3,
          justifyContent: "center",
        }}
      >
        {aiTools.map((tool) => (
          <BaseBox
            key={tool.id}
            onClick={() => handleCardClick(tool.id)}
            sx={{
              p: 3,
              borderRadius: "16px",
              backgroundColor:
                selectedProcess === tool.id ? "#e0f7fa" : "background.paper",
              boxShadow:
                selectedProcess === tool.id
                  ? "0 6px 14px rgba(0,0,0,0.25)"
                  : "0 3px 8px rgba(0,0,0,0.12)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              textAlign: "center",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              },
            }}
          >
            <BaseTypography sx={{ fontSize: "2rem" }}>
              {tool.icon}
            </BaseTypography>
            <BaseTypography sx={{ fontWeight: 600, mt: 1 }}>
              {tool.title}
            </BaseTypography>
            <BaseTypography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mt: 0.5,
              }}
            >
              {tool.desc}
            </BaseTypography>
          </BaseBox>
        ))}
      </BaseBox>
    </BaseBox>
  );
}

export default AIMode;
